if (!customElements.get('ucg-video')) {
class ucgVideo extends HTMLElement {
constructor() {
    super();
    this.swiperInstances = {};
}

connectedCallback() {
    this.init();
}

init() {
    this.clickAndDrag('.ugc-slide-wrapper');
    this.discriptionToggle();
    this.initSlide();
    this.closePopup();
    this.qntChange();
    this.variantChange();
    this.toggleSound();
    this.pdpOptMobile();
    this.handleAtc();
}

initSlide() {
    const popSlider = this.querySelector('.ugc-wrapper .ugc-pop-slider .swiper');
    const mainSlider = this.querySelector('.ugc-slide-wrapper .swiper');
    
    if (!popSlider || !mainSlider) return;
    
    if (this.swiperInstances.swiper1) {
        this.swiperInstances.swiper1.destroy(true, true);
    }
    if (this.swiperInstances.swiper2) {
        this.swiperInstances.swiper2.destroy(true, true);
    }
    
    this.swiperInstances.swiper1 = new Swiper(popSlider, {
        slidesPerView: 1, 
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        observer: true,
        direction: "horizontal",
        observeParents: true,
        navigation: {
            nextEl: this.querySelector(".ugc-wrapper .swiper-button-next"),
            prevEl: this.querySelector(".ugc-wrapper .swiper-button-prev"),
        },
        breakpoints: {
            768: {
                direction: 'horizontal',
                slidesPerView: 2,
                spaceBetween: 50,
                loop: true,
                navigation: {
                    nextEl: this.querySelector(".swiper-nagivations .swiper-button-next"),
                    prevEl: this.querySelector(".swiper-nagivations .swiper-button-prev"),
                }
            }
        },
        on: {
            click() {
                this.slideTo(this.clickedIndex);
            }
        }
    });
    
    this.swiperInstances.swiper2 = new Swiper(mainSlider, {
        slidesPerView: 1.6,
        spaceBetween: 25,
        loop: true,
        centeredSlides: true,
        pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
        },
        breakpoints: {
            991: {
                slidesPerView: 4.4,
                spaceBetween: 15,
                loop: true,
                centeredSlides: false,
            }
        }
    });
    
    this.playActiveVideo(this.swiperInstances.swiper1); 
    this.onClickSlidePopup(this.swiperInstances.swiper1);
}

playActiveVideo(swiper) {
    const safePlay = (video) => {
        if (!video) return;
        video.play().catch(() => {});
    };

    swiper.on('slideChangeTransitionEnd', () => {
        let videos = this.querySelectorAll('.ugc-pop-slider video');
        videos.forEach(video => video.pause());

        const activeVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide-active video');
        safePlay(activeVideo);

        const prevVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide-prev video');
        safePlay(prevVideo);

        const nextVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide-next video');
        safePlay(nextVideo);
    });
}

clickAndDrag(selector, scroll_speed = 2, classOnEvent = 'grabbed_elem') {
    const sliders = this.querySelectorAll(selector);
    let isDown = false;
    let startX;
    let scrollLeft;

    sliders.forEach(slider => {
        const centerNearestSlide = () => {
            const slides = slider.children;
            let sliderCenter = slider.offsetWidth / 2;
            let closestSlide = null;
            let closestDistance = Infinity;

            Array.from(slides).forEach(slide => {
                const slideRect = slide.getBoundingClientRect();
                const slideCenter = slideRect.left + slideRect.width / 2;
                const distance = Math.abs(slideCenter - sliderCenter);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestSlide = slide;
                }
            });

            if (closestSlide) {
                const slideRect = closestSlide.getBoundingClientRect();
                const offset = (slideRect.left + slideRect.width / 2) - sliderCenter;
                slider.scrollLeft += offset;
            }
        };
        
        if (window.innerWidth <= 767) {
            centerNearestSlide();
        }

        slider.addEventListener('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            slider.classList.add(classOnEvent);
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            if (isDown && window.innerWidth <= 767) {
                centerNearestSlide();
            }
            isDown = false;
            slider.classList.remove(classOnEvent);
        });

        slider.addEventListener('mouseup', () => {
            if (isDown && window.innerWidth <= 767) {
                centerNearestSlide();
            }
            isDown = false;
            slider.classList.remove(classOnEvent);
        });

        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * scroll_speed;
            slider.scrollLeft = scrollLeft - walk;
        });
    });
}

discriptionToggle() {
    let readMoreBtns = this.querySelectorAll('.ugc-wrapper a.read-more');
    readMoreBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.closest('.p-descriotion').querySelector('.desc-data').classList.toggle('open');
            e.currentTarget.textContent == 'Read More' ? e.currentTarget.textContent = 'Read Less' : e.currentTarget.textContent = 'Read More';
        });
    });
}

onClickSlidePopup(swiper) {
    let slides = this.querySelectorAll('.ugc-slide-wrapper .card-wrapper');

    slides.forEach(slide => {
        slide.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.style.overflow = 'hidden';
            
            let curr_slide = parseInt(e.currentTarget.dataset.index, 10);
            swiper.slideToLoop(curr_slide);
            
            this.querySelector('.ugc-pop-slider').classList.remove('is_hidden');
            document.body.classList.add('shoppable-pop-up');
        });
    });
}

closePopup() {
    let popEle = this.querySelector('.popClose');
    if (!popEle) return;
    
    popEle.addEventListener('click', (e) => {
        e.currentTarget.closest('.ugc-pop-slider').classList.add('is_hidden');
        document.body.classList.remove('shoppable-pop-up');
        let popEle = this.querySelectorAll('.ugc-pop-slide-wrapper .content-wrapper');
        document.body.style.overflow = null;
        popEle.forEach(ele => {
            ele.classList.remove('active');
        });
    });
    
    let mobileOverlay = this.querySelectorAll('.content-wrapper .overlay');
    mobileOverlay.forEach(ele => {
        ele.addEventListener('click', (e) => {
            e.currentTarget.closest('.content-wrapper').classList.remove('active');
        });
    });
}

variantChange() {
    let variantRadios = this.querySelectorAll('.var-input');
    variantRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            let that = e.currentTarget;
            
            // Remove active class from all siblings in the same variant group
            const variantWrapper = that.closest('.variant-radio-wrapper');
            if (variantWrapper) {
                const allRadiosInGroup = variantWrapper.querySelectorAll('.var-input');
                allRadiosInGroup.forEach(r => {
                    const label = r.closest('label') || r.parentElement;
                    if (label) label.classList.remove('active');
                });
                
                // Add active class to selected option
                const selectedLabel = that.closest('label') || that.parentElement;
                if (selectedLabel) selectedLabel.classList.add('active');
            }
            
            const hiddenInput = that.closest('.variant-radio-wrapper').querySelector('[type="hidden"]');
            if (hiddenInput) {
                hiddenInput.value = that.value;
            }
            
            const productContainer = that.closest('.ugc-pop-slide-item');
            if (!productContainer) {
                console.error('Product container not found');
                return;
            }
            
            const productJsonElement = productContainer.querySelector('[data-product-json]');
            if (!productJsonElement) {
                console.error('Product JSON element not found');
                return;
            }
            
            try {
                let productJson = JSON.parse(productJsonElement.textContent);
                let varJson = productJson.variants;
                
                let valOption1 = productContainer.querySelector('input[name="position_1"]');
                let valOption2 = productContainer.querySelector('input[name="position_2"]');
                let valOption3 = productContainer.querySelector('input[name="position_3"]');
                
                let atcBtn = that.closest('form')?.querySelector('[data-atc]');
                if (!atcBtn) {
                    console.error('Add to cart button not found');
                    return;
                }
                
                // Get option values, defaulting to null if element doesn't exist
                const option1Value = valOption1 ? valOption1.value : null;
                const option2Value = valOption2 ? valOption2.value : null;
                const option3Value = valOption3 ? valOption3.value : null;
                
                let currVarJSON = varJson.filter(item => {
                    return (
                        (item?.option1 === option1Value) && 
                        (item?.option2 === option2Value) && 
                        (item?.option3 === option3Value)
                    );
                });
                
                if (!currVarJSON.length) {
                    console.error('No matching variant found');
                    return;
                }
                
                currVarJSON = currVarJSON[0];
                
                const contentWrapper = that.closest('.content-wrapper');
                if (contentWrapper) {
                    // Update prices in the form's content-header
                    const formHeaderPrice = contentWrapper.querySelector('.content-header .p-price');
                    if (formHeaderPrice) {
                        const formMainPrice = formHeaderPrice.querySelector('.main-price');
                        const formComparePrice = formHeaderPrice.querySelector('.compare_at_price');
                        const formSaleOff = formHeaderPrice.querySelector('.sale-off');
                        
                        if (formMainPrice) {
                            const formattedPrice = (currVarJSON.price / 100).toFixed(2);
                            formMainPrice.textContent = `$${formattedPrice}`;
                        }
                        
                        if (formComparePrice) {
                            if (currVarJSON.compare_at_price && currVarJSON.compare_at_price > currVarJSON.price) {
                                const formattedComparePrice = (currVarJSON.compare_at_price / 100).toFixed(2);
                                formComparePrice.textContent = `$${formattedComparePrice}`;
                                formComparePrice.style.display = 'inline';
                            } else {
                                formComparePrice.style.display = 'none';
                            }
                        }
                        
                        if (formSaleOff) {
                            const originalPrice = currVarJSON.compare_at_price;
                            const salePrice = currVarJSON.price;
                            
                            if (originalPrice && salePrice && originalPrice > salePrice) {
                                const discountPercentage = ((originalPrice - salePrice) / originalPrice) * 100;
                                formSaleOff.textContent = `${Math.round(discountPercentage)}%`;
                                formSaleOff.style.display = 'inline';
                            } else {
                                formSaleOff.style.display = 'none';
                            }
                        }
                    }
                    
                    // Also update the price in the action-header (popup trigger area)
                    const headerPriceWrapper = that.closest('.ugc-pop-slide-wrapper').querySelector('.action-header .p-price');
                    if (headerPriceWrapper) {
                        const headerMainPrice = headerPriceWrapper.querySelector('.main-price');
                        const headerComparePrice = headerPriceWrapper.querySelector('.compare_at_price');
                        const headerSaleOff = headerPriceWrapper.querySelector('.sale-off');
                        
                        if (headerMainPrice) {
                            const formattedPrice = (currVarJSON.price / 100).toFixed(2);
                            headerMainPrice.textContent = `$${formattedPrice}`;
                        }
                        
                        if (headerComparePrice) {
                            if (currVarJSON.compare_at_price && currVarJSON.compare_at_price > currVarJSON.price) {
                                const formattedComparePrice = (currVarJSON.compare_at_price / 100).toFixed(2);
                                headerComparePrice.textContent = `$${formattedComparePrice}`;
                                headerComparePrice.style.display = 'inline';
                            } else {
                                headerComparePrice.style.display = 'none';
                            }
                        }
                        
                        if (headerSaleOff) {
                            const originalPrice = currVarJSON.compare_at_price;
                            const salePrice = currVarJSON.price;
                            
                            if (originalPrice && salePrice && originalPrice > salePrice) {
                                const discountPercentage = ((originalPrice - salePrice) / originalPrice) * 100;
                                headerSaleOff.textContent = `${Math.round(discountPercentage)}%`;
                                headerSaleOff.style.display = 'inline';
                            } else {
                                headerSaleOff.style.display = 'none';
                            }
                        }
                    }
                }
                
                const variantIdInput = productContainer.querySelector('[name="id"]');
                if (variantIdInput) {
                    variantIdInput.value = currVarJSON.id;
                }
                
                if (currVarJSON.available) {
                    atcBtn.textContent = 'Add to cart';
                    atcBtn.removeAttribute('disabled');
                } else {
                    atcBtn.textContent = 'Sold out';
                    atcBtn.setAttribute('disabled', '');
                }
            } catch (error) {
                console.error('Error updating variant:', error);
            }
        });
    });
}

qntChange() {
    let incBtn = this.querySelectorAll('.qnt-wrapper .inc');
    let decBtn = this.querySelectorAll('.qnt-wrapper .dec');
    
    incBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
            let qntInput = e.currentTarget.closest('.qnt-wrapper').querySelector('[name="quantity"]');
            qntInput.value = parseInt(qntInput.value) + 1;
        });
    });
    
    decBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
            let qntInput = e.currentTarget.closest('.qnt-wrapper').querySelector('[name="quantity"]');
            if(qntInput.value > 1) qntInput.value = parseInt(qntInput.value) - 1;
        });
    });
}

toggleSound() {
    let toggleBtn = this.querySelectorAll('.ugc-wrapper .ugc-pop-slide-wrapper .volume-handle');
    toggleBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
            let video = e.currentTarget.closest('.video-wrapper').querySelector('video');
            video.muted = !video.muted;
            e.currentTarget.classList.toggle('unmuted');
        });
    });
}

pdpOptMobile() {
    let trigger = this.querySelectorAll('.action-wrapper [popup-trigger]');
    trigger.forEach(btn => {
        btn.addEventListener('click', (e) => {
            let that = e.currentTarget;
            e.preventDefault();
            that.closest('.ugc-pop-slide-wrapper').querySelector('.content-wrapper').classList.toggle('active');
            that.closest('.ugc-pop-slide-wrapper').querySelector('.content-wrapper a').focus();
        });
    });
}

handleAtc() {
    let atcBtns = this.querySelectorAll('[data-atc]');
    atcBtns.forEach(btn => {
        if (btn.ugcAtcHandler) {
            btn.removeEventListener('click', btn.ugcAtcHandler);
        }
        btn.ugcAtcHandler = this.atcClickHandler;
        btn.addEventListener('click', this.atcClickHandler);
    });
}

atcClickHandler = async (e) => {
    let that = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    
    let qnt = that.closest('form').querySelector('[name="quantity"]').value;
    let id = that.closest('form').querySelector('[name="id"]').value;

    let bodyData = {
        "quantity": parseInt(qnt), 
        "id": id,
        "sections": "cart_data,mini_cart",
        "sections_url": window.location.pathname
    };
    
    that.setAttribute('disabled','');
    
    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST', 
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyData)
        });
        
        const responseData = await res.json();
        that.removeAttribute('disabled');
        
        let successMsg;
        if (responseData.status == 422) {
            successMsg = `<div class="atc-sucess">${responseData.description}</div>`;
            that.insertAdjacentHTML("afterend", successMsg);
            setTimeout(() => {
                if (that.nextSibling) that.nextSibling.remove();  
            }, 2000);
        } else {
            if (typeof T4SThemeSP !== 'undefined') {
                T4SThemeSP.isATCSuccess = false;
            }
            
            if (typeof responseData.sections !== 'undefined' && typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart && T4SThemeSP.Cart.renderContents) {
                try {
                    T4SThemeSP.Cart.renderContents(responseData.sections);
                    setTimeout(() => {
                        T4SThemeSP.isATCSuccess = true;
                    }, 100);
                } catch (err) {
                    console.error('Error using T4SThemeSP.Cart.renderContents:', err);
                    T4SThemeSP.isATCSuccess = true;
                }
            } else {
                const cartDataResponse = await fetch('/cart.js');
                const parsedCart = await cartDataResponse.json();
                
                const drawerRes = await fetch('/?sections=mini_cart&t=' + Date.now());
                const drawerData = await drawerRes.json();
                const drawerEl = document.querySelector('#t4s-mini_cart');
                
                if (drawerEl && drawerData['mini_cart']) {
                    drawerEl.innerHTML = drawerData['mini_cart'];
                    
                    setTimeout(() => {
                        if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.ProductAjax && T4SThemeSP.ProductAjax.change) {
                            T4SThemeSP.ProductAjax.change();
                        }
                    }, 300);
                }
                
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedCart } }));
                document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: parsedCart } }));
            }
            
            successMsg = `<div class="atc-sucess">Product added to cart</div>`;
            that.insertAdjacentHTML("afterend", successMsg);
            setTimeout(() => {
                if (that.nextSibling) that.nextSibling.remove();  
            }, 2000);
        }
    } catch (err) {
        console.log('Error adding to cart:', err);
        that.removeAttribute('disabled');
    }
}

disconnectedCallback() {
    if (this.swiperInstances.swiper1) {
        this.swiperInstances.swiper1.destroy(true, true);
    }
    if (this.swiperInstances.swiper2) {
        this.swiperInstances.swiper2.destroy(true, true);
    }
}
}

customElements.define('ucg-video', ucgVideo);
}